import { render, staticRenderFns } from "./RelatorioAtendentePlano.vue?vue&type=template&id=81541f4e&"
import script from "./RelatorioAtendentePlano.vue?vue&type=script&lang=js&"
export * from "./RelatorioAtendentePlano.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioAtendentePlano.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports